import { createApp } from 'vue';
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import App from './App.vue';
import router from './router';
import './styles/index.scss';
import './styles/websocket-indicators.css';
import './styles/mobile/index.scss';
import './styles/mobile/components.scss';
import { setupResizeObserverErrorHandler, setupMobileResizeObserverFix, fixElementPlusResizeObserver } from './utils/resizeObserverFix';
import { runMobileTestSuite } from './utils/mobileTest';
// 设置ResizeObserver错误处理（在创建应用之前）
setupResizeObserverErrorHandler();
setupMobileResizeObserverFix();
fixElementPlusResizeObserver();
const app = createApp(App);
// 注册 Element Plus 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
}
app.use(createPinia());
app.use(router);
app.use(ElementPlus, {
    locale: zhCn,
});
// 全局错误边界处理
app.config.errorHandler = (err, vm, info) => {
    console.error('Global error:', err, info);
    // 根据错误类型提供不同的处理
    if (err instanceof TypeError && err.message.includes('Cannot read property')) {
        console.warn('Property access error, likely due to reactive data not being ready');
    }
    else if (err instanceof ReferenceError) {
        console.error('Reference error, check for undefined variables or functions');
    }
    else {
        // 对于其他类型的错误，显示用户友好的消息
        import('element-plus').then(({ ElMessage }) => {
            ElMessage.error('系统错误，请刷新页面重试');
        });
    }
};
// 全局未捕获的Promise错误处理
window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled promise rejection:', event.reason);
    // 防止默认的控制台错误输出
    event.preventDefault();
    // 显示用户友好的错误消息
    import('element-plus').then(({ ElMessage }) => {
        ElMessage.error('网络请求失败，请检查网络连接');
    });
});
app.mount('#app');
// 在开发环境中运行移动端测试套件
if (process.env.NODE_ENV === 'development') {
    setTimeout(() => {
        runMobileTestSuite();
    }, 2000); // 延迟2秒执行，确保应用完全加载
}
